import React, { useState, useRef, useCallback, useEffect } from 'react';
import { OV_STRINGS } from '../../constants/strings';
import styles from './NoticeStep.module.scss';

// actionArea가 body 위에 겹치는 높이 (padding 16*2 + button 48)
const ACTION_AREA_HEIGHT = 80;

function NoticeStep({ ticketQuantity = 1, onNext, onClose }) {
  const [agreed, setAgreed] = useState(false);
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const bodyRef = useRef(null);

  const validDays = ticketQuantity * 30;
  const notices = [
    { title: OV_STRINGS.NOTICE_ITEM_1_TITLE(validDays), desc: OV_STRINGS.NOTICE_ITEM_1_DESC(validDays), icon: '🏅' },
    { title: OV_STRINGS.NOTICE_ITEM_2_TITLE, desc: OV_STRINGS.NOTICE_ITEM_2_DESC, icon: '🚨' },
    { title: OV_STRINGS.NOTICE_ITEM_3_TITLE, desc: OV_STRINGS.NOTICE_ITEM_3_DESC, icon: '🙋🏻‍♂️' },
  ];

  const handleBodyScroll = useCallback(() => {
    const el = bodyRef.current;
    if (!el) return;
    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight <= 8;
    setIsAtBottom(atBottom);
    if (atBottom && !hasScrolledToBottom) {
      setHasScrolledToBottom(true);
    }
  }, [hasScrolledToBottom]);

  // 내용이 짧아 스크롤 불필요한 경우 즉시 잠금 해제
  useEffect(() => {
    setTimeout(() => {
      const el = bodyRef.current;
      if (el && el.scrollHeight - el.clientHeight <= 8) {
        setHasScrolledToBottom(true);
        setIsAtBottom(true);
      }
    }, 0);
  }, []);

  // actionArea가 가리는 영역을 빼고 스크롤 — 현재 보이는 하단이 정확히 상단으로 이동
  const handleScrollDown = () => {
    const el = bodyRef.current;
    if (el) el.scrollBy({ top: el.clientHeight - ACTION_AREA_HEIGHT, behavior: 'smooth' });
  };

  return (
    <>
      <div className={styles.overlay} onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }} />
      <div className={styles.modalContent}>
        <div className={styles.modal}>

          <div className={styles.nav}>
            <span className={styles.badge}>{OV_STRINGS.BADGE_LABEL_VERIFY}</span>
            <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="닫기">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6l12 12" stroke="#171719" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </button>
          </div>

          <div className={styles.header}>
            <h2 className={styles.title}>{OV_STRINGS.NOTICE_TITLE}</h2>
            <p className={styles.desc}>{OV_STRINGS.NOTICE_DESC}</p>
          </div>

          <div className={styles.body} ref={bodyRef} onScroll={handleBodyScroll}>

            <div className={styles.noticeList}>
              {notices.map((item, i) => (
                <div key={i} className={styles.noticeCard}>
                  <span className={styles.noticeIcon}>{item.icon}</span>
                  <div className={styles.noticeText}>
                    <strong className={styles.noticeTitle}>{item.title}</strong>
                    <p className={styles.noticeDesc}>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className={styles.detailSection}>
              <div className={styles.detailBox}>
                <div className={styles.detailHeading}>
                  <span className={styles.detailHeadingLabel}>{OV_STRINGS.NOTICE_DETAIL_TOGGLE}</span>
                  <span className={styles.needCheckBadge}>확인필요</span>
                </div>
                <div className={styles.detailContent}>
                  {OV_STRINGS.NOTICE_DETAILS.map((text, i) => (
                    <p key={i} className={`${styles.detailItem} ${i === 0 ? styles.detailItemHighlight : ''}`}>{text}</p>
                  ))}
                </div>
              </div>
            </div>

            <div className={styles.agreeSection}>
              <button
                type="button"
                className={`${styles.agreeButton} ${
                  agreed ? styles.agreeButtonChecked
                    : !hasScrolledToBottom ? styles.agreeButtonDisabled
                    : ''
                }`}
                onClick={() => hasScrolledToBottom && setAgreed((prev) => !prev)}
              >
                <span className={`${styles.checkboxIcon} ${agreed ? styles.checkboxChecked : ''}`} />
                <span>{OV_STRINGS.NOTICE_AGREE}</span>
              </button>
            </div>
          </div>

          {!isAtBottom && (
            <>
              <div className={styles.bodyGradient} />
              <button
                type="button"
                className={styles.scrollToBottomBtn}
                onClick={handleScrollDown}
              >
                아래로 스크롤하기
              </button>
            </>
          )}

          <div className={styles.actionArea}>
            <button
              type="button"
              className={`${styles.nextButton} ${agreed ? styles.active : ''}`}
              disabled={!agreed}
              onClick={onNext}
            >
              {OV_STRINGS.NEXT}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default NoticeStep;
